import { ClickOutside } from 'utils/click-outside'

import {
  ImageGallery, BackButton, BusinessInquiryForm, Cart, Category, Checkout, DPicker, Embed, EventForm, Forms, Header, Layout, Loader, LogoSlider, MobileNav, MyPageUsers, Product, QtyControl, RangeSlider, Scroll, Subnav, UserManagement, AuthForm, CartModal
} from 'components'

const App = {
  init: () => {
    Loader.init()
    Scroll.init()
    Header.init()
    Embed.init()
    Cart.init()
    QtyControl.init()
    Product.init()
    MobileNav.init()
    Checkout.init()
    Layout.init()
    MyPageUsers.init()
    EventForm.init()
    RangeSlider.init()
    Forms.init()
    DPicker.init()
    UserManagement.init()
    Subnav.init()
    Category.init()
    BusinessInquiryForm.init()
    BackButton.init()
    ImageGallery.init()
    LogoSlider.init()
    AuthForm.init()
    CartModal.init()

    // Last...
    ClickOutside(() => {})
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.querySelector('.body').classList.remove('preload')
  }, 100);

  App.init()
})
